<dx-drawer class="drawer" position="before" [closeOnOutsideClick]="shaderEnabled" [openedStateMode]="menuMode"
  [revealMode]="menuRevealMode" [minSize]="minMenuSize" [shading]="shaderEnabled" [(opened)]="menuOpened">

  <app-side-navigation-menu [compactMode]="!menuOpened && minMenuSize > 0" [selectedItem]="selectedRoute"
    [expandedWidth]="sidebarWidth" [collapsedWidth]="minMenuSize" [ngClass]="swatchClassName"
    *dxTemplate="let dataMenu of 'panel'" (selectedItemChanged)="navigationChanged($event)"
    (openMenu)="navigationClick()">
    <div class="sidebar-header" [class.compact]="!menuOpened && minMenuSize > 0">
      <img src="assets/icons/sidebar_logo2.png" class="sidebar-header-logo" alt="NHM Maharashtra"/>
      <img src="assets/icons/sidebar_logo1.png" class="sidebar-header-logo" alt="Arogya Vibhag"/>
      <button *ngIf="shaderEnabled && menuOpened" class="sidebar-close-btn" type="button" (click)="closeSidebarMobile($event)" title="Close menu">
        <i class="dx-icon dx-icon-close"></i>
      </button>
    </div>
  </app-side-navigation-menu>

  <div class="container">
    <app-header [menuToggleEnabled]="true" (menuToggle)="toggleMenu($event)">
    </app-header>

    <dx-scroll-view class="layout-body with-footer" [useNative]="true">
      <div class="sty">
        <ng-content></ng-content>
      </div>
    </dx-scroll-view>
  </div>
</dx-drawer>